const BUCKET_NAME = 'folders';

export default class ThingFoldersController {
    /** @ngInject */
    constructor(EventEmitter) {
        this.eventEmitter = EventEmitter;
    }

    $onInit() {
        this.selectedItems = [];
        this.folderModel = {};
    }

    showSelectedFolders() {
        this.triggerExpansionOfSelected = true;
    }

    unselectFolders() {
        this.selectedItems = this.selectedItems.filter((folderId) => {
            delete this.folderModel[folderId];
            return false;
        });
        this.prepareBucket();
    }

    folderModelChanged({ folderIds }) {
        this.selectedItems = folderIds;
        this.prepareBucket();
    }

    prepareBucket() {
        if (this.selectedItems.length) {
            this.addItemToBucket(
                this.eventEmitter({
                    item: {
                        name: BUCKET_NAME,
                        value: this.selectedItems
                    }
                })
            );
        } else {
            this.removeItemFromBucket(
                this.eventEmitter({
                    item: {
                        name: BUCKET_NAME
                    }
                })
            );
        }
    }

}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-folders/thing-folders.controller.js